<template>
  <header class="site-header">
    <!-- ===== 顶部信息条 ===== -->
    <!-- <div class="topbar">
      <div class="topbar-inner">
        <div class="topbar-left">
          <span class="topbar-text">成立于 2009 年 · 家电 / 照明 / 塑料 / 五金制造与进出口</span>
        </div>
        <div class="topbar-right">
          <a class="topbar-link" href="tel:13958349372">📞 13958349372</a>
          <a class="topbar-link" href="mailto:17371988805@163.com">✉ 17371988805@163.com</a>
        </div>
      </div>
    </div> -->

    <!-- ===== 主导航 ===== -->
    <div class="nav-main" :class="{ scrolled: scrolled }" @mouseleave="closeDropdown()">
      <div class="nav-inner">
        <!-- 品牌区 -->
        <div class="brand" @click="goHome">
          <img class="brand-logo" src="../static/logo.webp" alt="技明电器" />
          <div class="brand-text">
            <div class="brand-name">余姚市技明电器有限公司</div>
            <div class="brand-sub">YUYAO JIMING ELECTRIC APPLIANCE CO., LTD.</div>
          </div>
        </div>

        <!-- 桌面导航 -->
        <nav class="nav">
          <template v-for="item in navItems" :key="item.key">
            <div class="nav-item-wrap" @mouseenter="openDropdown(item)">
              <a
                class="nav-item"
                :class="{ active: isActive(item), 'has-drop': item.children }"
                @click="onNavClick(item)"
              >
                {{ item.label }}
                <span v-if="item.children" class="caret" aria-hidden="true">▾</span>
              </a>

              <!-- 下拉菜单 -->
              <div v-if="item.children && dropdownKey === item.key" class="dropdown">
                <div class="dropdown-inner">
                  <a
                    v-for="child in item.children"
                    :key="child.key"
                    class="drop-link"
                    @click="onChildClick(item, child)"
                  >
                    <span class="drop-dot" aria-hidden="true"></span>
                    <span class="drop-label">{{ child.label }}</span>
                  </a>
                </div>
              </div>
            </div>
          </template>
        </nav>

        <!-- 右侧操作 -->
        <div class="actions">
          <a class="btn-cta" href="tel:13958349372">
            <span class="btn-cta-ico" aria-hidden="true">☎</span>
            立即咨询
          </a>
          <button
            class="burger"
            type="button"
            :class="{ open: mobileOpen }"
            @click="mobileOpen = !mobileOpen"
            aria-label="菜单"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
    </div>

    <!-- ===== 移动端菜单 ===== -->
    <transition name="slide">
      <div v-if="mobileOpen" class="mobile-menu">
        <a
          v-for="item in navItems"
          :key="item.key"
          class="m-item"
          :class="{ active: isActive(item) }"
          @click="onNavClick(item)"
        >
          {{ item.label }}
        </a>
        <a class="m-item m-item-cta" href="tel:13958349372">☎ 立即咨询：13958349372</a>
      </div>
    </transition>
  </header>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const scrolled = ref(false);
const mobileOpen = ref(false);
const dropdownKey = ref(null);

const navItems = [
  { key: "home", label: "首页", to: "/" },
  {
    key: "product",
    label: "产品与服务",
    to: { path: "/productService", query: { key: "brand" } },
    children: [
      { key: "brand", label: "全品类制造加工", to: { path: "/productService", query: { key: "brand" } } },
      { key: "appliance", label: "家用电器制造", to: { path: "/", hash: "#biz" } },
      { key: "lighting", label: "照明灯具制造", to: { path: "/", hash: "#biz" } },
      { key: "plastic", label: "塑料制品制造", to: { path: "/", hash: "#biz" } },
      { key: "hardware", label: "五金件制造", to: { path: "/", hash: "#biz" } },
      { key: "laser", label: "工业激光定位灯系列", to: { path: "/", hash: "#product" } },
    ],
  },
  { key: "solution", label: "应用行业", to: "/solution" },
  { key: "service", label: "服务支持", to: "/service" },
  { key: "cases", label: "客户案例", to: "/CustomerCases" },
  { key: "about", label: "关于我们", to: "/AboutUs" },
];

function isActive(item) {
  if (item.key === "home") return route.path === "/";
  if (item.key === "product") return route.name === "productService";
  if (item.key === "solution") return route.name === "solution";
  if (item.key === "service") return route.name === "service";
  if (item.key === "cases") return route.name === "CustomerCases";
  if (item.key === "about") return route.name === "AboutUs";
  return false;
}

function openDropdown(item) {
  if (item.children) dropdownKey.value = item.key;
}

function closeDropdown() {
  dropdownKey.value = null;
}

function goHome() {
  mobileOpen.value = false;
  router.push("/");
}

function onNavClick(item) {
  mobileOpen.value = false;
  closeDropdown();
  if (item.to) router.push(item.to);
}

function onChildClick(parent, child) {
  mobileOpen.value = false;
  closeDropdown();
  router.push(child.to);
}

function onScroll() {
  scrolled.value = window.scrollY > 10;
}

onMounted(() => {
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});
</script>

<style scoped>
.site-header {
  position: relative;
  z-index: 100;
}

/* ===== 顶部信息条 ===== */
.topbar {
  background: #0a4f97;
  color: rgba(255, 255, 255, 0.92);
  font-size: 13px;
}

.topbar-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 6px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.topbar-right {
  display: flex;
  gap: 20px;
}

.topbar-link {
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
  transition: opacity 0.2s;
}

.topbar-link:hover {
  opacity: 0.75;
}

/* ===== 主导航 ===== */
.nav-main {
  position: sticky;
  top: 0;
  background: #ffffff;
  border-bottom: 1px solid #eef1f5;
  transition: box-shadow 0.25s ease;
}

.nav-main.scrolled {
  box-shadow: 0 8px 24px rgba(10, 79, 151, 0.1);
}

.nav-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

/* 品牌 */
.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  flex: 0 0 auto;
}

.brand-logo {
  height: 48px;
  width: auto;
  max-width: 140px;
  object-fit: contain;
  border-radius: 8px;
  flex: 0 0 auto;
}

.brand-name {
  font-size: 19px;
  font-weight: 800;
  color: #102a43;
  letter-spacing: 0.5px;
  line-height: 1.2;
}

.brand-sub {
  font-size: 10px;
  color: #7b8a9c;
  letter-spacing: 0.4px;
  margin-top: 3px;
}

/* 导航 */
.nav {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 100%;
}

.nav-item-wrap {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 16px;
  height: 100%;
  font-size: 15px;
  color: #33475b;
  cursor: pointer;
  user-select: none;
  border-bottom: 3px solid transparent;
  transition: color 0.2s, border-color 0.2s;
}

.nav-item:hover {
  color: #0a4f97;
}

.nav-item.active {
  color: #0a4f97;
  font-weight: 700;
  border-bottom-color: #0a4f97;
}

.caret {
  font-size: 11px;
  opacity: 0.7;
}

/* 下拉 */
.dropdown {
  position: absolute;
  top: calc(100% - 3px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 220px;
  padding-top: 3px;
}

.dropdown-inner {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 18px 40px rgba(16, 42, 67, 0.14);
}

.drop-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  color: #33475b;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}

.drop-link:hover {
  background: #eef5fd;
  color: #0a4f97;
}

.drop-dot {
  width: 6px;
  height: 6px;
  border-radius: 99px;
  background: #b9c7d8;
  flex: 0 0 auto;
  transition: background 0.18s;
}

.drop-link:hover .drop-dot {
  background: #0a4f97;
}

/* 右侧操作 */
.actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.btn-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 22px;
  border-radius: 999px;
  background: linear-gradient(135deg, #0b66bb, #0a4f97);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 8px 18px rgba(10, 79, 151, 0.28);
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(10, 79, 151, 0.36);
}

.btn-cta-ico {
  font-size: 15px;
}

/* 汉堡按钮 */
.burger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 42px;
  height: 42px;
  padding: 0 9px;
  border: 1px solid #e3e9f1;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
}

.burger span {
  height: 2px;
  border-radius: 2px;
  background: #33475b;
  transition: transform 0.25s, opacity 0.25s;
}

.burger.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.burger.open span:nth-child(2) {
  opacity: 0;
}

.burger.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ===== 移动端菜单 ===== */
.mobile-menu {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 280px;
  max-width: 82vw;
  background: #fff;
  box-shadow: -12px 0 40px rgba(16, 42, 67, 0.18);
  padding: 84px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
  z-index: 120;
}

.m-item {
  padding: 14px 12px;
  border-radius: 10px;
  font-size: 15px;
  color: #33475b;
  cursor: pointer;
}

.m-item:hover,
.m-item.active {
  background: #eef5fd;
  color: #0a4f97;
}

.m-item-cta {
  margin-top: 12px;
  background: linear-gradient(135deg, #0b66bb, #0a4f97);
  color: #fff;
  font-weight: 700;
  text-align: center;
}

.m-item-cta:hover {
  color: #fff;
  background: linear-gradient(135deg, #0b66bb, #0a4f97);
}

/* 过渡动画 */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.28s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}

/* ===== 响应式 ===== */
@media (max-width: 1080px) {
  .nav {
    display: none;
  }

  .burger {
    display: flex;
  }

  .brand-sub {
    display: none;
  }
}

@media (max-width: 640px) {
  .topbar-left {
    display: none;
  }

  .topbar-inner {
    justify-content: center;
  }

  .brand-name {
    font-size: 16px;
  }

  .btn-cta {
    display: none;
  }
}
</style>
